module.exports = __webpack_public_path__ + "img/imgYLSYB(2).60ae88a4.png";